import React, { Component, Fragment } from "react";

import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import MessageHandler from "../../components/MessageHandler/MessageHandler";
import { required, length } from "../../util/validators";
import Loader from "../../components/Loader/Loader";
import Newloader from "../../components/Loader/NewLoader/NewLoader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import BrandForm from "../../components/Brand/BrandForm/BrandForm";
import Paginator from '../../components/Paginator/Paginator';

import "./Brand.css";

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  enTitle: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  description: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 70 })],
  },
  origin: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
  imageUrl: {
    value: "",
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [required],
  },
  categoryCode: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
};

class Brand extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brands: [],
      active: false,
      showMessage: false,
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
      totalBrands: 0,
      perPage: 5,
      brandPage: 1,
      brandsLoading: true,
    };
  }

   componentDidMount() {
    this.loadBrands(1);
  }

  
  toggleClass() {
    this.setState({
      active: this.state.active ? false : true,
      isEditing: false,
      editingData: {}
    });
  }

  onDeleteBrandHandler = (data) => {
    const Index = this.state.brands.findIndex((p) => p.code === data.code);

    this.setState({
      code: data.code,
      showMessage: true,
      label: data.label,
      title: this.state.brands[Index].title,
    });
  };

  onEditBrandHandler = (data) => {
    const Index = this.state.brands.findIndex((p) => p.code === data.code);  
    
    this.setState({
      active: true,
      isEditing: true,
      editingData: this.state.brands[Index]
    });

    // this.props.onEditHandler.bind(this, {
    //   code: this.state.code,
    //   label: this.state.label,
    // });
  };

  onCancelBrandHandler = () => {
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });
  };
  onDeleteBrandTypeDicisionHandler = () => {
      this.props.onDeleteDataHandler({
      code: this.state.code,
      label: this.state.label,
    });
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });    
  };


  onEditHandler = () => {
    this.setState({
      isEditing: true,
    });
  };
  onDeleteHandler = (data) => {
      const graphqlQuery = {
        query: `
        mutation {
          deleteBrand(code: ${parseInt(data.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            throw new Error("خطا در حذف برند!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedPosts = [...prevState.brands];
            const postIndex = prevState.brands.findIndex(
              (p) => p.code === data.code
            );
            if (postIndex > -1) {
              updatedPosts.splice(postIndex, 1);
            }

            return {
              brands: updatedPosts,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });        
  };

  loadBrands = (brandPage) => {
    if (brandPage) {
      this.setState({ brandsLoading: true, brands: [] });
    }

    const graphqlQuery = {
        query: `
          query FetchBrands($page: Int, $perPage: Int) {
            allBrands(page: $page, perPage: $perPage) {
              Brands {
                code
                title
                enTitle
                imageUrl
                description
                origin
                isActive
              }
              totalBrands
            }
          }
        `,
      variables: {
        page: brandPage,
        perPage: this.state.perPage
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            brands: resData.data.allBrands.Brands,
            totalBrands: resData.data.allBrands.totalBrands,
            brandsLoading: false,
            brandPage: brandPage 
        });
           
      })
      .catch(this.catchError);
  };

  acceptBrandChangeHandler = (postData) => {
    this.setState({
      editLoading: true,
    });
    const formData = new FormData();
    formData.append("image", postData.imageUrl);
    if (postData.oldImageUrl !== "") {
      formData.append("oldPath", postData.oldImageUrl);
    }
    console.log(postData.imageUrl);
    fetch(process.env.REACT_APP_BACKEND_URL + "/post-image", {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + this.props.token,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((fileResData) => {
        
        const imageUrl = fileResData.filePath || "undefined";
        let graphqlQuery;
        if (postData.editingCode !== 0) {
            graphqlQuery = {
              query: `
                mutation updatedBrand($code: Int!, $categoryCode: Int!, $title: String!, $enTitle: String!, $imageUrl: String!, $description: String!, $origin: Boolean!, $isActive: Boolean!) {
                  updateBrand(code: $code, brandInput: {categoryCode: $categoryCode, title: $title, enTitle: $enTitle, imageUrl: $imageUrl, description: $description, origin: $origin, isActive: $isActive}) {
                    code
                    title
                    enTitle
                    imageUrl
                    description
                    origin
                    isActive
                  }
                }
              `,
              variables: {
                code: postData.editingCode,
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                description: postData.description,
                origin: postData.origin,
                imageUrl: imageUrl,
                isActive: true,
              },
            };
        } else {
            graphqlQuery = {
              query: `
                mutation createNewBrand($categoryCode: Int!, $title: String!, $enTitle: String!, $imageUrl: String!, $description: String!, $origin: Boolean!, $isActive: Boolean!) {
                  createBrand(brandInput: {categoryCode: $categoryCode, title: $title, enTitle: $enTitle, imageUrl: $imageUrl, description: $description, origin: $origin, isActive: $isActive}) {
                    code
                    title
                    enTitle
                    imageUrl
                    description
                    origin
                    isActive
                  }
                }
              `,
              variables: {
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                description: postData.description,
                origin: postData.origin,
                imageUrl: imageUrl,
                isActive: true,
              },
            };     
        }     

        return fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
          method: "POST",
          body: JSON.stringify(graphqlQuery),
          headers: {
            Authorization: "Bearer " + this.props.token,
            "Content-Type": "application/json",
          },
        });
      })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let resDataField = "createBrand";
        if (postData.editingCode !== 0) {
          resDataField = "updateBrand";          
        }

        var post = {
          code: resData.data[resDataField].code,
          title: resData.data[resDataField].title,
          enTitle: resData.data[resDataField].enTitle,
          imageUrl: resData.data[resDataField].imageUrl,
          description: resData.data[resDataField].description,
          origin: resData.data[resDataField].origin,
          isActive: resData.data[resDataField].isActive,
        };

        this.setState((prevState) => {
            let updatedTotalBrands = prevState.totalBrands;
            let updatedPosts = [...prevState.brands];
            if (postData.editingCode !== 0) {
              const postIndex = prevState.brands.findIndex(
                (p) => p.code === post.code
              );
              updatedPosts[postIndex] = post;
            } else {
              updatedTotalBrands++;
              if (prevState.brands.length >= prevState.perPage) {
                updatedPosts.pop();
              }
              updatedPosts.unshift(post);
            }

            

      // perPage: 10,
      // brandPage: 1,

            return {
              active: false,
              brands: updatedPosts,
              totalBrands: updatedTotalBrands
            };
          
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editBrand: false,
          editLoading: false,
          error: err,
        });
      });
  };

  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelBrandHandler}
          message={
            "آیا می‌خواهید " +
            this.state.label +
            ' کالایی "' +
            this.state.title +
            '" را حذف کنید؟'
          }
          onCancelModal={this.onCancelBrandHandler}
          onAcceptModal={this.onDeleteBrandTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <Content>
            <ContentHeader
              headerAction="درج برند"
              headerDescription="اطلاعات برندها را در این صفحه وارد کنید"
            />
            <Card> 
                <span className="mn-promo-report__header-card-bold-title">جستجو و فیلتر</span>
                <div className="mn-card__body">
                    <form className="mn-ui-form" method="POST" id="searchForm" onSubmit={e => { e.preventDefault(); }}>
                        <div className="mn-ui-form__row mn-ui-form__row_padding">
                            <div className="mn-grid__row mn-grid__row--gap-lg mn-brand-card__footer">
                                <div className="c-ui-paginators">
                                    <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12 mn-grid__col--xs-gap" style={{minWidth: '400px'}}>
                                        <label className="uk-form-label uk-flex uk-flex-between">جستجو:</label>
                                        <div className="field-wrapper ui-select ui-select__container">
                                            <div className="mn-ui-input">
                                                <input type="text" name="brand-search" className="mn-ui-input__field mn-ui-input__field--order" id="brand-search" placeholder="عبارت مورد نظرتان را وارد کنید..."/>
                                            </div>                                        
                                        </div>
                                    </div>
                                    <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                        <button className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active mn-search-btn--search-form mn-search_padding" id="submitButton">
                                            <span className="mn-seach__btn">جستجو</span>
                                        </button>
                                        <button type="button" className="mn-content-categories__search-reset" id="resetButton"></button>
                                    </div>
                                </div>
                                <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                    <button onClick={this.toggleClass.bind(this)} type="button" className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding" id="submitButton">
                                        <span className="mn-seach__btn">ایجاد برند جدید</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div
                      className={[
                        "mn-grid__row mn-brand__gap",
                        `${!this.state.active ? "uk-hidden" : ""}`,
                      ].join(" ")}
                    >
                      <BrandForm
                        toggleClass={this.toggleClass.bind(this)}
                        onAcceptModal={this.acceptBrandChangeHandler.bind( this )}
                        isEditing={this.state.isEditing}
                        editingData={this.state.editingData}
                        userId={this.props.userId}
                        token={this.props.token}
                      />
                    </div>             

                </div>
            </Card>
            <Card>
                <div className="c-card__wrapper">
                    <div className="mn-card__header mn-card__header--table">
                        <Paginator
                          onNext={this.loadBrands.bind(this)}
                          lastPage={Math.ceil(this.state.totalBrands / this.state.perPage)}
                          totalBrands={this.state.totalBrands}
                          currentPage={this.state.brandPage}
                        />
                    </div>
                    <div className={[ "c-card__body c-ui-table__wrapper", this.state.brandsLoading ? "c-content-loading" : "" ].join(" ")}>
                        <table className="c-ui-table   js-search-table " data-sort-column="" data-sort-order="asc" data-search-url="/commissions/search/" data-auto-reload-seconds="0" data-new-ui="1" data-is-header-floating="1" data-has-checkboxes="">
                            <thead>
                                <tr className="c-ui-table__row">
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="js-search-table-column">ردیف</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">تصویر برند</span>
                                    </th>
                                
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">نام برند</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                    <span className="table-header-searchable">نام انگلیسی برند</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">ویرایش برند</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">حذف برند</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.brands !== [] && (
                                <Fragment>
                                    {this.state.brands.map((data, index) => (
                                    <tr>
                                        <td className="c-ui-table__cell c-ui-table__cell--smaller">
                                        {index + 1}
                                        </td>
                                        <td className="c-ui-table__cell">
                                        <div className="mn-content-upload__img-container mn-content-upload__img-container-noborder">
                                            <img src={'https://api.shirazpc.com/'+data.imageUrl} alt="" className="mn-content-upload__img js-upload-thumb"/>                            
                                        </div>
                                        </td>
                                        <td className="c-ui-table__cell">{data.title}</td>
                                        <td className="c-ui-table__cell">{data.enTitle}</td>
                                        
                                        <td className="c-ui-table__cell ">
                                        <span
                                            className="mn-link-row__status-ui edit"
                                            onClick={this.onEditBrandHandler.bind(this, {
                                            code: data.code,
                                            })}
                                        >
                                            {"ویرایش"}
                                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                        </span>
                                        </td>
                                        <td className="c-ui-table__cell">
                                        <span
                                            className="mn-link-row__status-ui delete"
                                            onClick={this.onDeleteHandler.bind(this, {
                                            code: data.code,
                                            })}
                                        >
                                            {"حذف"}
                                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                                        </span>
                                        </td>
                                    </tr>
                                    ))}
                                </Fragment>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="c-card__footer">
                        <Paginator
                          onNext={this.loadBrands.bind(this)}
                          lastPage={Math.ceil(this.state.totalBrands / this.state.perPage)}
                          totalBrands={this.state.totalBrands}
                          currentPage={this.state.brandPage}
                        />
                    </div>
                    {this.state.brandsLoading && (
                      <div className="c-content-loader">
                        <Newloader/>
                      </div>
                    )}
                </div>
            </Card>
        </Content>
      </Fragment>
    );
  }
}

export default Brand;











{/* <div id="newBrandRequestModal" className="marketplace-redesign uk-modal c-variant uk-open" uk-modal="" style="display: block;">
    <div className="uk-modal-dialog uk-modal-dialog--confirm uk-modal-body c-content-modal" id="newBrandRequestModalContent">
        <button className="uk-modal-close uk-modal-close--search uk-close uk-icon" type="button" uk-close=""><svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" ratio="1"><line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line><line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line></svg></button>
        <form id="newBrandRequestForm" novalidate="novalidate">
            <input type="hidden" name="brand[product_id]" value="">
            <input type="hidden" name="brand[category_id]" id="newBrandRequestCategoryIdContainer">
            <div className="c-content-modal__header c-content-modal__header--overflow">
                <h3 className="c-content-modal__title"> درخواست ایجاد برند جدید</h3>
            </div>
            <div className="c-content-modal__body c-content-modal__body--overflow">
                <div className="c-content-modal__body-container">
                    <div className="c-content-modal__intro">فروشگاه اینترنتی دیجی‌کالا این امکان را برای فروشنده فراهم
                        کرده
                        تا کالایش را با برند (نام
                        تجاری) خودش نمایش دهد و به فروش برساند. برای ایجاد و ثبت برندتان، فرم زیر را تکمیل کنید.
                    </div>
                    <div className="c-content-modal__notes">
                        <span className="c-content-modal__notes-title">توجه:</span>
                        <ul className="c-content-modal__notes-list">
                            <li>نام برند مورد نظرتان را وارد کنید و درصورتی‌که برند را در این لیست پیدا نکردید، در صفحه‌ی درخواست برند، برند مورد نظرتان را جست‌و‌جو کرده و در صورت یافتن آن، روی دکمه‌ی افزودن برند به گروه کالایی کلیک کنید.</li>
                            <li>چنانچه، برند مورد نظر در این لیست وجود نداشت، برای ساخت برند جدید، اطلاعات ذکر شده در این صفحه را ارسال کنید.</li>
                            <li className="c-content-modal__notes-item">- برندهای ایرانی باید گواهی ثبت علامت تجاری
                                داشته باشند و تصویر آن را باید همراه با
                                درخواست در فرم ارسال فرمایید.
                            </li>
                            <li className="c-content-modal__notes-item">- برندهای ایرانی که دارای گواهی ثبت علامت تجاری
                                نیستند، ثبت نمی‌شوند.
                            </li>
                            <li className="c-content-modal__notes-item">- برای ثبت برند، اظهار نامه‌ قابل قبول نیست و
                                حتما باید گواهی ثبت برند را ارسال
                                کنید.
                            </li>
                        </ul>
                    </div>
                    <div className="c-variant-error hidden c-variant-error__box c-variant-error__box--modal mt-20 mb-20" id="ajaxBrandErrorsList"></div>
                    <div className="c-grid__row c-grid__row--gap-lg mt-30">
                        <div className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial c-grid__col--lg-6">
                            <label for="" className="uk-form-label">
                                نام فارسی برند:
                                <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper c-autosuggest">
                                <div className="search-form__autocomplete js-autosuggest-box">
                                    
                                <input id="searchKeywordInput" className="uk-input js-prevent-submit" type="text" name="brand[name_fa]" placeholder="نام فارسی برند را وارد کنید …"><ul className="c-autosuggest__list-container" style="display: none;"></ul></div>
                            </div>
                        </div>
                        <div className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial c-grid__col--lg-6">
                            <label for="" className="uk-form-label">
                                نام انگلیسی برند:
                                <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper c-autosuggest">
                                <div className="search-form__autocomplete js-autosuggest-box">
                                    
                                <input id="searchKeywordInput" className="uk-input js-prevent-submit" type="text" name="brand[name_en]" placeholder="عنوان انگلیسی برند …"><ul className="c-autosuggest__list-container" style="display: none;"></ul></div>
                            </div>
                        </div>
                    </div>
                    <div className="c-grid__row c-grid__row--gap-lg">
                        <div className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial">
                            <label className="uk-form-label">
                                شرح برند:
                                <span className="uk-form-label__required"></span>
                            </label>
                            <div id="brandDescription" className="field-wrapper has-error">
                                <textarea name="brand[description]" className="uk-textarea" cols="" rows="3" placeholder="توضیحات برند باید بین ۷۰ تا ۱۰۰ کلمه درباره‌ی تاریخچه و محصولات برند باشد …" aria-describedby="brand[description]-error" aria-invalid="true"></textarea>
                            <div id="brand[description]-error" className="error error-msg">وارد کردن شرح برای برند اجباری است</div></div>
                        </div>
                    </div>
                    <div className="c-grid__row c-grid__row--gap-lg">
                                                <div className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial c-grid__col--lg-6 c-grid__col--row-attr">
                            <label className="uk-form-label">
                                نوع برند:
                                <span className="uk-form-label__required"></span>
                            </label>
                            <div id="brandOrigin" className="field-wrapper">
                                <label className="c-ui-radio c-ui-radio--content c-ui-checkbox--auto">
                                    <input type="radio" className="c-ui-radio__origin js-brand-origin" name="brand[origin]" value="iranian" id="iranianBrandContainer" checked="">
                                    <span className="c-ui-radio__check c-ui-radio__check--content"></span>
                                    <span className="c-ui-radio__label c-ui-radio__label--content">ایرانی</span>
                                </label>
                                <label className="c-ui-radio c-ui-radio--content c-ui-checkbox--auto">
                                    <input type="radio" className="c-ui-radio__origin js-brand-origin" name="brand[origin]" id="foreignBrandContainer" value="foreign">
                                    <span className="c-ui-radio__check c-ui-radio__check--content"></span>
                                    <span className="c-ui-radio__label c-ui-radio__label--content">خارجی</span>
                                </label>
                            </div>
                        </div>
                        <div id="foreignBrandContainer1" className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial c-grid__col--lg-6 c-grid__col--row-attr hidden">
                            <label className="uk-form-label">
                                لینک سایت معتبر خارجی:
                                <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper">
                                <input name="brand[url]" className="uk-input uk-input--ltr" placeholder="http://">
                            </div>
                        </div>
                    </div>
                    <div className="c-grid__row c-grid__row--gap-lg">
                        <div id="iranianBrandContainer1" className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial c-grid__col--lg-6 c-grid__col--row-attr">
                            <label className="uk-form-label">
                                برگه ثبت برند یا لینک سایت قوه قضاییه:
                                <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper">
                                <div id="newBrandSheetUpload" for="brandRegistrationSheet" className="c-content-modal__uploads-label empty">
                                    <span uk-form-custom="" className="uk-form-custom">
                                        <input id="brandRegistrationSheet" type="file" className="hidden">
                                    </span>
                                    <label for="brandRegistrationSheet" className="c-content-modal__uploads-preview">
                                        <img src="" id="newBrandSheetUploadPreview" className="c-content-modal__uploads-img" alt="">
                                        <span className="c-content-upload__img-loader js-img-loader">
                                            <span className="progress__wrapper">
                                                <span className="progress"></span>
                                            </span>
                                        </span>
                                    </label>
                                    <span className="c-content-modal__list c-content-modal__uploads-tooltips">
                                        <span className="c-content-modal__uploads-text">ابعاد
                                            برگه ثبت برند را با حداکثر حجم ۷۰۰ مگابایت و فرمت PNG یا JPEG  بارگذاری کنید.
                                        </span>
                                    </span>
                                </div>
                                <input type="hidden" name="brand[registration_image_id]" className="force-validation" id="registrationImageTempId" value="">
                                <div className="c-content-modal__errors-full" id="newBrandRegistrationImageUploadErrors"></div>
                            </div>
                        </div>
                        <div id="iranianBrandLogo" className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial c-grid__col--lg-6 c-grid__col--row-attr">
                            <label className="uk-form-label">
                                لوگوی برند:
                                <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper">
                                <div id="newBrandLogoUpload" className="c-content-modal__uploads-label empty">
                                    <span uk-form-custom="" className="uk-form-custom">
                                        <input id="brandLogoFile" type="file" className="hidden">
                                    </span>
                                    <label for="brandLogoFile" className="c-content-modal__uploads-preview">
                                        <img src="" id="newBrandLogoUploadPreview" className="c-content-modal__uploads-img" alt="">
                                        <span className="c-content-upload__img-loader js-img-loader">
                                            <span className="progress__wrapper">
                                                <span className="progress"></span>
                                            </span>
                                        </span>
                                    </label>
                                    <span className="c-content-modal__list c-content-modal__uploads-tooltips">
                                        <span className="c-content-modal__uploads-text">
                                            لوگو برند را در ابعاد ۶۰۰×۶۰۰ پیکسل و با فرمت PNG یا JPEG و پس‌زمینه‌ی سفید بارگذاری کنید.
                                        </span>
                                    </span>
                                </div>
                                <input type="hidden" name="brand[logo_id]" className="force-validation" id="logoImageTempId" value="">
                                <div className="c-content-modal__errors-full" id="newBrandLogoUploadErrors"></div>
                            </div>
                        </div>
                        <div id="iranianBrandContainer2" className="c-grid__col c-grid__col--gap-lg c-grid__col--flex-initial c-grid__col--lg-6">
                            <label className="uk-form-label">
                                یا لینک سایت قوه قضاییه را وارد کنید. لینک را به صورت کامل وارد کنید:
                                <span className="uk-form-label__required"></span>
                            </label>
                            <div className="field-wrapper">
                                <input name="brand[registration_url]" type="text" className="uk-input uk-input--ltr" placeholder="http://" id="registrationUrlValue">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                        <div className="c-content-modal__footer c-content-modal__footer--overflow">
                <button className="modal-footer__btn modal-footer__btn--confirm modal-footer__btn--wide js-modal-uploads-confirm js-accept" type="button" id="saveBrandRequestButton">
                    <span id="brandSuggestBtnLabel" className="hidden">افزودن برند به گروه کالایی</span>
                    <span id="brandRequestBtnLabel">ارسال درخواست</span>
                </button>
                <button className="modal-footer__btn modal-footer__btn--wide hidden" type="button" id="resetBrandRequestBtn">انتخاب مجدد
                </button>
                <button className="modal-footer__btn modal-footer__btn--wide uk-modal-close js-decline" type="button" id="cancelBrandRequestButton">انصراف
                </button>
            </div>
        </form>
        <div className="c-content-loader">
            <div className="c-content-loader__logo"></div>
            <div className="c-content-loader__spinner"></div>
        </div>
    </div>
</div> */}


     {/* <form className="c-card search-form" id="findProductForm" autocomplete="off">
	<input type="hidden" name="find_product[category_id]" value="" id="searchCategoryId">
	<input type="hidden" name="find_product[brand_id]" value="" id="searchBrandId">
	<input type="hidden" name="find_product[fake]" value="" id="searchFake">
	<input type="hidden" name="find_product[status]" value="" id="searchStatus">
	<input type="hidden" name="find_product[keyword]" value="کتا" id="searchKeyword">
	<input type="hidden" name="find_product[page]" value="1" id="searchPage">
	<input type="hidden" name="find_product[itemsPerPage]" value="10" id="searchItemsPerPage"> 
	<div className="c-card__body c-card__body--content">
		<label for="" className="search-form__action-label">جستجوی کالا در میان کالاهای دیجی‌کالا بر اساس:</label>
		<div className="search-form__autocomplete-container">
			<div className="search-form__autocomplete js-autosuggest-box">
				<input id="searchKeywordInput" className="uk-input js-prevent-submit" type="text" placeholder="نام محصول یا DKP"/>
				<ul className="c-autosuggest__list-container" style={{display: 'none'}}>
					<li className="c-autosuggest__list-item"><a className="js-auto-suggest" href="javascript:" data-category="5918" data-keyword="کتاب"><span>کتاب</span> در گروه <span>کتاب چاپی</span></a>
					</li>
					<li className="c-autosuggest__list-item"><a className="js-auto-suggest" href="javascript:" data-category="8303" data-keyword="کتابخانه"><span>کتابخانه</span> در گروه <span>کتابخانه</span></a>
					</li>
					<li className="c-autosuggest__list-item"><a className="js-auto-suggest" href="javascript:" data-category="6623" data-keyword="نشانگر کتاب"><span>نشانگر کتاب</span> در گروه <span>نشانگر کتاب</span></a>
					</li>
					<hr/>
					<li className="c-autosuggest__list-item"><a className="js-auto-complete" data-keyword="کتاب">کتاب</a>
					</li>
					<li className="c-autosuggest__list-item"><a className="js-auto-complete" data-keyword="کتابخانه">کتابخانه</a>
					</li>
					<li className="c-autosuggest__list-item"><a className="js-auto-complete" data-keyword="کتاب کودک">کتاب کودک</a>
					</li>
					<li className="c-autosuggest__list-item"><a className="js-auto-complete" data-keyword="نشانگر کتاب">نشانگر کتاب</a>
					</li>
					<li className="c-autosuggest__list-item"><a className="js-auto-complete" data-keyword="کتاب رمان">کتاب رمان</a>
					</li>
				</ul>
			</div>
			<div className="c-content-accordion__step-controls c-content-accordion__step-controls--category">
				<button id="searchButton" className="search-form__btn search-form__btn--search" type="button">جستجو</button>
				<button id="searchReset" type="button" className="c-content-categories__search-reset "></button>
			</div>
		</div>
	</div>
</form>*/}